import React, { useState } from "react";
import { handleError, handleSuccess } from "../../../../Utils";
import { getEmail } from "../../../../DecodeToken/DecodeToken";
import { updateMentorSessions } from "../../../../ApiServices/ApiServices";
import { getSessionDetails } from "../Sessions";

const UpdateExistingSessions = ({
  isVisible,
  setIsVisible,
  index,
  title,
  setTitle,
  type,
  setType,
  duration,
  setDuration,
  amount,
  setAmount,
  setSessionsDetails,
  setLoading,
}) => {
  const email = getEmail();

  const handleSubmit = async () => {
    if (!title) {
      return handleError("Title cannot be empty");
    }
    if (type==='Video Call' && !duration) {
          return handleError("Duration cannot be empty");
        }
    if (!amount) {
      return handleError("Amount cannot be empty");
    }
    try {
      const response = await updateMentorSessions(
        email,
        title,
        type,
        type==='Video Call'?duration:"",
        amount,
        index
      );
      setTitle("");
      setType("");
      setDuration("");
      setAmount("");
      setIsVisible(false);
      getSessionDetails(email, setSessionsDetails, setLoading);
      return handleSuccess(response.message);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  return (
    <>
      {isVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg">
            <h2 className="text-lg font-bold mb-4">Update Sessions</h2>
            <form>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-2">Title</label>
                <input
                  type="text"
                  placeholder="Name of Session"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-indigo-300"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-600 font-medium text-[15px]">
                  Type
                </label>
                <select
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:border-blue-500 focus:outline-none"
                >
                  <option value="" disabled>
                    Select session type
                  </option>
                  <option value="Video Call">Video Call</option>
                  <option value="DM">DM</option>
                  <option value="Referral">Referral</option>
                </select>
              </div>
              {type === "Video Call" && (
                <div className="mb-4">
                  <label className="block text-gray-600 font-medium text-[15px]">
                    Duration (in minutes)
                  </label>
                  <input
                    type="number"
                    value={duration}
                    onChange={(e) => setDuration(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md focus:border-blue-500 focus:outline-none"
                  />
                </div>
              )}
              <div className="mb-4">
                <label className="block text-sm font-medium mb-2">
                  Amount (₹)
                </label>
                <input
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-indigo-300"
                />
              </div>
              <div className="flex justify-end space-x-2">
                <button
                  type="button"
                  onClick={() => setIsVisible(false)}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
                >
                  Close
                </button>
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdateExistingSessions;
